import {
  Accordion,
  Button,
  Group,
  Modal,
  Radio,
  TextInput,
  Textarea,
  ActionIcon,
  rem,
  Select,
  Text,
  Flex,
  Box,
  Popover,
  Stack,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import moment from "moment";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getColor } from "../../pages/Home/Medication";
import {
  createMar,
  getMar,
  updateMedicationAdministration,
} from "../../services";
import { decrypt, firstLetterCap, showInfo } from "../../utils";
import useStyles from "./style";
import DeleteComponent from "./DeleteComponent";
import { IconAlertTriangle, IconClock } from "@tabler/icons-react";
import CloseCircle from "../CloseCircle";
import NarcoticBox from "../NarcoticBox";
import { DateInput, DatePicker, DateTimePicker } from "@mantine/dates";
import { useRef } from "react";
import { TimeInput } from "@mantine/dates";
import swal from "sweetalert";
import { IconChevronDown } from "@tabler/icons-react";
import { getAllSignatures } from "../../services/signature";
import dayjs from "dayjs";
import { SlCalender } from "react-icons/sl";

const MedicationModal = ({
  date,
  opened,
  onclose,
  data,
  allData,
  isViewOpen,
  futureDate,
  isActivity,
}) => {
  // console.log("🚀 ~ MedicationModal ~ data:", data); 
  const { classes } = useStyles();
  const ref = useRef(null);
  const _medicationType = data?.medicationType;
  const _outOfMedication = "Out of Medication";
  const _upcoming = "upcoming";
  const { staff } = useSelector((state) => state?.staff);

  const [validation, setValidation] = useState({
    outcome: (value) => (value ? null : "Required"),
    comments: (value) => (value ? null : "Required"),
  });
  const [btnLoading, setBtnLoading] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const { selectedClient } = useSelector((state) => state.mar);
  const { profile } = useSelector((state) => state.profile);
  let userid = profile?.user?.id;
  let userType = profile?.user?.type;
  let role = profile?.user?.role;
  const [selectedStaff, setSelectedStaff] = useState();
  const { allSignature } = useSelector((state) => state?.signature);
  const [dateTimeOpened, setDateTimeOpened] = useState(false);

  // const [populateStaff, setPopulateStaff] = useState();
  // useEffect(() => {
  //   const staffOptions =
  //     staff?.staffs?.map((item) => ({
  //       value: item?.id,
  //       label: item?.name,
  //     })) || [];

  //   const defaultStaff = profile?.user?.id
  //     ? {
  //         value: profile?.user?.id,
  //         label: profile?.user?.name,
  //       }
  //     : null;

  //   // Add default staff if not already in the list
  //   const isDefaultInList = staffOptions.some(
  //     (opt) => opt.value === defaultStaff?.value
  //   );
  //   const finalOptions =
  //     defaultStaff && !isDefaultInList
  //       ? [defaultStaff, ...staffOptions]
  //       : staffOptions;

  //   setPopulateStaff(finalOptions);
  //   setSelectedStaff(defaultStaff?.value || null);
  // }, [staff, profile]);

  // const staffOptions =
  //   staff?.staffs?.map((item) => ({
  //     value: item?.id,
  //     label: item?.name,
  //   })) || [];

  // // Default selected staff from profile
  // const defaultStaff = profile?.user?.id
  //   ? {
  //       value: profile?.user?.id,
  //       label: profile?.user?.name,
  //     }
  //   : null;

  // // Ensure the default staff is in the options list (to avoid issues)
  // const populatedOptions =
  //   defaultStaff &&
  //   !staffOptions.find((opt) => opt.value === defaultStaff.value)
  //     ? [defaultStaff, ...staffOptions]
  //     : staffOptions;

  const assignedStaffIds = selectedClient?.staff
    ?.filter((s) => s?.isAssign === true)
    ?.map((s) => s?.staffId);

  const populateStaff = staff?.staffs
    ?.filter((staff) => assignedStaffIds?.includes(staff?.id))
    ?.map((staff) => ({
      label: staff?.name,
      value: staff?.id,
    }));
  const form = useForm({
    initialValues: {
      quantity: "0",
      reason: "",
      comments: "",
      outcome: "",
    },
    validate: validation,
  });
  useEffect(() => {
    setValidation((prevValidation) => ({
      ...prevValidation,
    }));
  }, [form?.values?.outcome]);
  // useEffect(() => {
  //   getAllSignatures();
  // }, []);

  useEffect(() => {
    if (isViewOpen) {
      form.setFieldValue("quantity", String(data?.dosage));
      form.setFieldValue("outcome", _medicationType);
      form.setFieldValue("comments", data?.comments);
      // form.setFieldValue("reason", data?.reason);

      // Administration Form
      adminForm.setFieldValue("staff", data?.staff?.id);
      adminForm.setFieldValue("date", new Date(data?.createdAt));
      adminForm.setFieldValue("time", moment(data?.createdAt).format("HH:mm"));
    } else {
      form.setFieldValue(
        "quantity",
        String(data?.form3?.medicationadministered)
      );
    }
  }, [isViewOpen, data]);

  const [tempDate, setTempDate] = useState(
    form.values.createdAt ? new Date(form.values.createdAt) : null
  );
  const [tempTime, setTempTime] = useState(
    form.values.createdAt ? dayjs(form.values.createdAt).format("HH:mm") : ""
  );

  const formatDisplayValue = (date, time) => {
    if (!date) return "";

    if (time) {
      const [hours, minutes] = time.split(":");
      const dateTime = new Date(date);
      dateTime.setHours(parseInt(hours), parseInt(minutes));
      return dayjs(dateTime).format("MMM DD, YYYY - hh:mm A");
    }

    return dayjs(date).format("MMM DD, YYYY");
  };

  const handleDateTimeApply = () => {
    if (tempDate && tempTime) {
      const [hours, minutes] = tempTime.split(":");
      const dateTime = new Date(tempDate);
      dateTime.setHours(parseInt(hours), parseInt(minutes));

      form.setFieldValue("createdAt", dateTime);
      setDateTimeOpened(false);
    } else if (tempDate) {
      form.setFieldValue("createdAt", tempDate);
      setDateTimeOpened(false);
    }
  };

  const handleDateTimeClear = () => {
    setTempDate(null);
    setTempTime("");
    setDateTimeOpened(false);
  };

  useEffect(() => {
    if (dateTimeOpened && !form.values.createdAt) {
      setTempDate(new Date());
      setTempTime(dayjs().format("HH:mm"));
    }
  }, [dateTimeOpened]);

  const isValidDate = (d) => {
    if (Object.prototype.toString.call(d) === "[object Date]") {
      // it is a date
      if (isNaN(d)) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  const onSave = async (values) => {
    if (
      (Number(values?.quantity) > 0 && values?.outcome === "Taken") ||
      values?.outcome !== "Taken"
    ) {
      const getCreatedAt = () => {
        if (form.values?.createdAt) {
          return form.values.createdAt;
        }

        if (data?.timeSlot) {
          const today = moment().format("YYYY-MM-DD");
          const dateTime = moment(
            `${today} ${data.timeSlot}`,
            "YYYY-MM-DD hh:mm A"
          );

          return dateTime.toISOString(); // e.g. 2025-09-02T19:00:00.000Z
        }
        return moment().toISOString();
      };

      let obj = {
        client: selectedClient?.id,
        staff: selectedStaff || userid,
        medicationType:
          data?.form3?.medicationType === "PRN" ? "PRN" : values?.outcome,
        date: moment(data?.date).toISOString(),
        // createdAt: form.values?.createdAt || moment().toISOString(),
        createdAt: getCreatedAt(),
        comments: values?.comments,
        medicationDetails: [
          {
            marId: data?._id,
            medicationId: data?.medicationId,
            dosage: values?.outcome === "Taken" ? Number(values?.quantity) : 0,
            createdAt: getCreatedAt(),
          },
        ],
      };
      if (!isValidDate(new Date(data?.date))) {
        return showInfo("Please refresh page");
      }

      const sortMedicine = (data) => {
        return data.sort((a, b) => {
          const timeA =
            a?.medicationType !== "PRN"
              ? moment(a?.timeSlot, "hh:mm A").format("HH:mm")
              : moment(a?.createdAt).format("HH:mm");
          const timeB =
            b?.medicationType !== "PRN"
              ? moment(b?.timeSlot, "hh:mm A").format("HH:mm")
              : moment(b?.createdAt).format("HH:mm");

          return timeA.localeCompare(timeB);
        });
      };

      const dosage = values?.outcome === "Taken" ? Number(values?.quantity) : 0;

      let payload = {
        ...obj,
      };
      const filteredMed = sortMedicine(allData)?.filter(
        (_v) => _v?.medicationId === data?.medicationId
      );

      let selectedMedIndex = filteredMed?.findIndex(
        (_fm) => _fm?._id === data?._id
      );

      payload.included = filteredMed
        ?.slice(selectedMedIndex, filteredMed?.length)
        ?.map((_m, index) => {
          if (index == 0) {
            return {
              marId: _m?._id,
              medicationId: _m?.medicationId,
              dosage:
                values?.outcome === "Taken" ? Number(values?.quantity) : 0,
              slot: _m?.timeSlot,
              newMedicationType: values?.outcome,
              createdAt: getCreatedAt(_m),
            };
          } else {
            return {
              marId: _m?._id,
              medicationId: _m?.medicationId,
              dosage:
                values?.outcome === "Taken"
                  ? Number(_m?.dosage)
                  : Number(_m?.form3?.medicationadministered),
              slot: _m?.timeSlot,
              newMedicationType: _m?.medicationType,
            };
          }
        });

      setBtnLoading(true);
      try {
        let medicationRemaining =
          data?.form3?.medicineRemaining && data?.form3?.medicineRemaining > 0
            ? data?.form3?.medicineRemaining
            : data?.medicineRemaining;
        if (
          values?.outcome === "Taken" &&
          Number(dosage) > Number(medicationRemaining)
        ) {
          swal(
            "Oops! Something went wrong",
            "Administered Quantity is greater then available medicine count, Kindly select 'out of medicine' option from outcomes",
            "error"
          );
        } else {
          const res = await createMar(payload);
          if (res) {
            form.reset();
            setSelectedStaff();
            onclose();
            const calendar_view = localStorage.getItem("calendar_date");
            getMar(calendar_view, selectedClient?.id);
          }
        }
      } catch (error) {}
      setBtnLoading(false);
    } else {
      alert("Quantity is Required!");
    }
  };

  const adminForm = useForm({
    initialValues: {
      staff: data?.staff?.name,
      date: new Date(data?.createdAt),
      time: new Date(data?.createdAt),
    },
    validate: {
      staff: (value) => (value ? null : "Required"),
      date: (value) => (value ? null : "Required"),
      time: (value) => (value ? null : "Required"),
    },
  });

  const handleAdminBy = async (values) => {
    console.log("🚀 ~ handleAdminBy ~ values:", values)
    const date = moment(values?.date);
    const time = moment(values?.time, "hh:mm A");
    const mergedDateTime = moment(date).set({
      hour: time.hours(),
      minute: time.minutes(),
      second: 0,
    });

    const obj = {
      marId: data?._id,
      staff: values?.staff,
      createdAt: mergedDateTime?.toISOString(),
        medicationType:"SCHEDULE",
        form3: data?.form3,
    };
    setBtnLoading(true);
    await updateMedicationAdministration(obj);
    setBtnLoading(false);
    setIsEditOpen(false);
    setSelectedStaff();
    onclose();
    setIsEditOpen(false);
  };

  const selectedId = isEditOpen && !(userType === "staff" && role === "staff") ? adminForm?.values?.staff : data?.staff?.id
  const staffSignature = allSignature?.find(
    ({ staff, admin }) =>
      (staff &&
        staff === selectedId) ||
      (admin &&
        admin === selectedId)
  );

  return (
    <>
      <div style={{ overflowX: "auto" }}>
        <div style={{ minWidth: "600px" }}>
          <Modal
            className={classes.medicationModal}
            opened={opened}
            size={1200}
            onClose={() => {
              setSelectedStaff();
              onclose();
              setIsEditOpen(false);
            }}
            shadow="md"
            overlayProps={{ blur: 3 }}
            radius={"lg"}
            zIndex={2000}
            centered
          >
            <CloseCircle
              onclose={() => {
                setSelectedStaff();
                onclose();
                setIsEditOpen(false);
              }}
              marModal={true}
            />

            {isViewOpen ||
            _medicationType === "Missed" ||
            _medicationType === "upcoming" ? (
              <div
                style={{
                  position: "relative",
                  zIndex: 1000,
                  background: getColor(_medicationType)?.dark,
                }}
                className={`${classes.title}`}
              >
                <h2
                  style={{
                    color:
                      _medicationType === _outOfMedication ? "#fff" : "initial",
                  }}
                >
                  {firstLetterCap(data?.form3?.medicationName)}
                </h2>
                {data?.form3?.isNarcotic == "Yes" && <NarcoticBox />}
                {isActivity == true ? null : (
                  <span
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      right: 35,
                    }}
                  >
                    {profile?.user?.type !== "staff" &&
                      _medicationType !== _upcoming && (
                        <DeleteComponent
                          data={data}
                          onclose={() => onclose()}
                          type={"scheduled"}
                        />
                      )}
                  </span>
                )}
              </div>
            ) : data?.form3?.medicationType !== "PRN" ? (
              <div className={classes.upcomingHeader}>
                <img
                  src="/assets/images/prescription-icon.png"
                  alt="prescription"
                />
                <h2>Administer Scheduled Medication</h2>
              </div>
            ) : (
              <div className={classes.upcomingHeader}>
                <img
                  src="/assets/images/prescription-icon.png"
                  alt="prescription"
                />
                <h2>Administer PRN Medication</h2>
              </div>
            )}
            <div className={classes.mainContentWarpper}>
              <div className={classes.mainContent}>
                <div className={classes.details}>
                  {(_medicationType === "Missed" ||
                    _medicationType === "upcoming") && (
                    <Flex align={"center"} gap={10}>
                      {profile?.user?.role !== "staff" ? (
                        <Select
                          data={populateStaff}
                          value={selectedStaff}
                          placeholder="Select Staff"
                          label="Select Staff"
                          onChange={(e) => setSelectedStaff(e)}
                          rightSection={<IconChevronDown size={16} />}
                          withinPortal={false}
                          dropdownPosition="bottom"
                          maxDropdownHeight={200}
                          styles={{
                            dropdown: {
                              zIndex: 1000,
                            },
                          }}
                          // {...adminForm.getInputProps("staff")}
                        />
                      ) : (
                        <Text weight={600} ff={"Inter"} size={"sm"}>
                          {profile?.user?.name}
                        </Text>
                      )}
                      <p
                        style={{
                          textAlign: "left",
                          // marginTop: 0,
                          fontWeight: 600,
                          fontSize: "20px",
                          color: "#5C5C5C",
                        }}
                      >
                        {moment(date).format("MM/DD/YYYY")}
                      </p>
                    </Flex>
                  )}

                  {_medicationType === "Missed" && (
                    <div className={classes.missedBoxWrapper}>
                      <div className={"missedBox"}>
                        <IconAlertTriangle size={40} />
                        <p>MISSED</p>
                      </div>
                    </div>
                  )}

                  {_medicationType === "discontinued" && (
                    <div className={classes.discontinueBoxWrapper}>
                      <div className={"discontinedBox"}>
                        <IconAlertTriangle size={40} />
                        <p>DISCONTINUED</p>
                      </div>
                    </div>
                  )}

                  <div className={classes.head}>
                    <Flex gap="sm" direction="column" mt={20}>
                      {/* <Flex gap="5px" align="center" justify="center">
                        {data?.medicineRemaining === "unlimited" ? (
                          ""
                        ) : (
                          <>
                            <Text fw={600}>
                              {data?.form3?.medicineRemaining &&
                              data?.form3?.medicineRemaining === "unlimited" ? (
                                ""
                              ) : (
                                <>
                                {data?.form3.medicineRemaining}
                                </>
                              )}
                            </Text>
                            {data?.form3?.medicineRemaining === "unlimited" ? (
                              <></>
                            ) : (
                              <>
                                <Text fw={600}>Current Medication Count</Text>
                              </>
                            )}
                          </>
                        )}
                      </Flex> */}
                      <div
                        className={classes.box}
                        style={{
                          background:
                            getColor(_medicationType)?.light || "#fdf5e3",
                        }}
                      >
                        <h3
                          style={{
                            textTransform: "capitalize",
                            textAlign: "center",
                            color:
                              _medicationType === _outOfMedication
                                ? "#fff"
                                : "initial",
                          }}
                        >
                          {data?.medicineRemaining === "unlimited"
                            ? data?.medicineRemaining
                            : data?.medicineRemaining == null ||
                              data?.medicineRemaining == "null"
                            ? "0.0"
                            : data?.medicineRemaining}
                        </h3>
                        {data?.medicineRemaining !== "unlimited" && (
                          <p
                            style={{
                              color:
                                _medicationType === _outOfMedication
                                  ? "#fff"
                                  : "initial",
                            }}
                          >
                            of{" "}
                            {data?.totalMedicine === "unlimited"
                              ? data?.totalMedicine
                              : data?.totalMedicine}{" "}
                            <br />
                            Remaining
                          </p>
                        )}
                      </div>
                    </Flex>

                    <div>
                      {
                        <div className={`${classes.detailTitle}`}>
                          {!isViewOpen &&
                            _medicationType !== "Missed" &&
                            _medicationType !== "upcoming" && (
                              <h2>{data?.form3?.medicationName}</h2>
                            )}
                          {data?.form3?.isNarcotic === "Yes" &&
                            !isViewOpen &&
                            _medicationType !== "Missed" &&
                            _medicationType !== "upcoming" && <NarcoticBox />}
                        </div>
                      }
                      <p>
                        <span className={classes.span1}>
                          {data?.form3?.frequency}
                        </span>
                        <span className={classes.span2}>
                          {data?.form3?.dosage}
                          {data?.form3?.unit} {data?.form3?.ingestionMode}
                          {data?.form3?.dosageForm}
                        </span>
                        <span className={classes.span3}>{data?.timeSlot}</span>
                      </p>
                    </div>
                  </div>
                  <div className={classes.medicationBox}>
                    <Accordion variant="contained">
                      <Accordion.Item
                        value="use"
                        style={{
                          borderRadius: "15px",
                          background: "#F2F2F2",
                          marginBottom: "10px",
                        }}
                      >
                        <Accordion.Control>Use of Medication</Accordion.Control>
                        <Accordion.Panel>
                          {data?.form3?.medicationUse}
                        </Accordion.Panel>
                      </Accordion.Item>
                    </Accordion>
                    <Accordion variant="contained">
                      <Accordion.Item
                        value="instruction"
                        style={{
                          borderRadius: "15px",
                          background: "#F2F2F2",
                          marginBottom: "10px",
                        }}
                      >
                        <Accordion.Control>
                          Medication Instruction
                        </Accordion.Control>
                        <Accordion.Panel>
                          {data?.form3?.medicationInstruction}
                        </Accordion.Panel>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                  <form
                    className={classes.modalBody}
                    onSubmit={form?.onSubmit((values) => onSave(values))}
                  >
                    <div className={classes.outcome}>
                      <div className={classes.quantity}>
                        <TextInput
                          size="xl"
                          radius="xl"
                          type="number"
                          id="change-quantity"
                          className={classes.quantityInput}
                          {...form.getInputProps("quantity")}
                          defaultValue={form.values.quantity}
                          disabled={isViewOpen || futureDate == 1}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => {
                            let value = e.target.value;
                            if (value.includes(".")) {
                              const [integerPart, decimalPart] =
                                value.split(".");
                              if (decimalPart.length > 1) {
                                value = `${integerPart}.${decimalPart.slice(
                                  0,
                                  1
                                )}`;
                              }
                            }
                            form.setFieldValue("quantity", value);
                          }}
                          // min={0}
                          // disabled={isViewOpen || data?.form3?.discontinued}
                        />
                        <p>Quantity Dispensed</p>
                      </div>
                      {data?.form3?.medicationType !== "PRN" && (
                        <div className={classes.dispensed}>
                          <h3>
                            Outcomes <span className={classes.redText}>*</span>
                          </h3>
                          <div className={classes.radioContainer}>
                            <Radio.Group
                              label=""
                              defaultValue={form?.values.outcome}
                              onChange={(value) => {
                                form.setFieldValue("outcome", value);
                                // if (value !== "Unable to Take") {
                                //   form.setFieldValue("reason", null);
                                // }
                                if (value === "Taken") {
                                  setValidation({
                                    outcome: (value) =>
                                      value ? null : "Required",
                                  });
                                } else {
                                  setValidation({
                                    outcome: (value) =>
                                      value ? null : "Required",
                                    comments: (value) =>
                                      value ? null : "Required",
                                  });
                                }
                              }}
                              required
                              withAsterisk
                            >
                              <Group mt="xs">
                                {isViewOpen &&
                                // !data?.form3?.discontinued &&
                                form?.values.outcome === "Taken" ? (
                                  <div className={classes.statusBox}>
                                    <img
                                      src={"/assets/images/done-icon.png"}
                                      alt="done"
                                    />
                                    <p style={{ color: "#167207" }}>Taken</p>
                                  </div>
                                ) : (
                                  <Radio
                                    id="taken-medicine"
                                    disabled={
                                      isViewOpen || futureDate == 1
                                      // || data?.form3?.discontinued
                                    }
                                    value="Taken"
                                    label="Taken"
                                  />
                                )}
                                {isViewOpen &&
                                // !data?.form3?.discontinued &&
                                form?.values.outcome === "Refused" ? (
                                  <div className={classes.statusBox}>
                                    <img
                                      src={"/assets/images/unavailable.png"}
                                      alt="unavailable"
                                    />
                                    <p style={{ color: "#6B9CFF" }}>Refused</p>
                                  </div>
                                ) : (
                                  <Radio
                                    disabled={
                                      isViewOpen || futureDate == 1
                                      // || data?.form3?.discontinued
                                    }
                                    value="Refused"
                                    label="Refused"
                                  />
                                )}
                                {isViewOpen &&
                                // !data?.form3?.discontinued &&
                                form?.values.outcome === "Unable to Take" ? (
                                  <div className={classes.statusBox}>
                                    <img
                                      src={"/assets/images/do-not-disturb.png"}
                                      alt="do not disturb"
                                    />
                                    <p style={{ color: "#FDD65B" }}>
                                      Unable to Take
                                    </p>
                                  </div>
                                ) : (
                                  <Radio
                                    disabled={
                                      isViewOpen || futureDate == 1
                                      // || data?.form3?.discontinued
                                    }
                                    value="Unable to Take"
                                    label="Unable to Take"
                                  />
                                )}
                                {isViewOpen &&
                                form?.values.outcome === "Out of Medication" ? (
                                  <div className={classes.statusBox}>
                                    <img
                                      src={"/assets/images/close-black.png"}
                                      alt="close"
                                    />
                                    <p style={{ color: "#black" }}>
                                      Out of Medication
                                    </p>
                                  </div>
                                ) : (
                                  <Radio
                                    disabled={
                                      isViewOpen || futureDate == 1
                                      // ||
                                      // (data?.medicineRemaining == "unlimited" &&
                                      //   data?.totalMedicine == "unlimited")
                                    }
                                    value="Out of Medication"
                                    label="Out of Medication"
                                  />
                                )}
                              </Group>
                            </Radio.Group>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* {form?.values?.outcome === "Unable to Take" && (
                      <div style={{ marginBottom: "20px" }}>
                        <Select
                          label="Reason"
                          data={[
                            {
                              value: "Therapeutic leave of absence (TLOA)",
                              label: "Therapeutic leave of absence (TLOA)",
                            },
                            {
                              value: "Hospitalization or Acute care",
                              label: "Hospitalization or Acute care",
                            },
                            {
                              value: "Surgery or Medical Procedures",
                              label: "Surgery or Medical Procedures",
                            },
                            {
                              value: "Travel or Relocation",
                              label: "Travel or Relocation",
                            },
                          ]}
                          size="sm"
                          disabled={isViewOpen}
                          rightSection={
                            <IoIosArrowDown color={"#FBAA0D"} size={25} />
                          }
                          style={{ marginBottom: "15px" }}
                          placeholder="Select Reason"
                          {...form.getInputProps("reason")}
                        />
                      </div>
                    )} */}

                    <div
                      className={classes.comments}
                      style={{ marginBottom: "20px" }}
                    >
                      <Textarea
                        id="dosage-completed"
                        minRows={6}
                        label="Comments"
                        disabled={
                          isViewOpen || futureDate == 1
                          // || data?.form3?.discontinued
                        }
                        placeholder="Enter comments here"
                        defaultValue={form.values.comments}
                        {...form.getInputProps("comments")}
                      />
                    </div>

                    {!isViewOpen && (
                      <Box w="320px">
                        <Box w="320px">
                          {/* <DateTimePicker
                            label="Select Administration date and time"
                            placeholder="Select Administration date and time"
                            timePickerProps={{
                              withDropdown: true,
                              popoverProps: { withinPortal: false },
                              format: "12h",
                            }}
                            valueFormat="MMM DD, YYYY - hh:mm A"
                            withAsterisk
                            size="md"
                            disabled={isViewOpen || futureDate == 1}
                            maxDate={new Date()}
                            defaultValue={form.values.createdAt}
                            popoverProps={{
                              withinPortal: false,
                              onOpen: () =>
                                setAdministrationDatePickerOpened(true),
                              onClose: () =>
                                setAdministrationDatePickerOpened(false),
                            }}
                            {...form.getInputProps("createdAt")}
                          /> */}

                          <Popover
                            opened={dateTimeOpened}
                            onClose={() => setDateTimeOpened(false)}
                            position="bottom-start"
                            withinPortal={false}
                            shadow="md"
                            radius="md"
                          >
                            <Popover.Target>
                              <TextInput
                                label="Select Administration date and time"
                                placeholder="Select Administration date and time"
                                value={formatDisplayValue(
                                  form.values.createdAt
                                    ? new Date(form.values.createdAt)
                                    : null,
                                  form.values.createdAt
                                    ? dayjs(form.values.createdAt).format(
                                        "HH:mm"
                                      )
                                    : ""
                                )}
                                onClick={() => {
                                  if (!(isViewOpen || futureDate == 1)) {
                                    if (!tempDate) setTempDate(new Date());
                                    if (!tempTime)
                                      setTempTime(dayjs().format("HH:mm"));
                                    setDateTimeOpened(true);
                                  }
                                }}
                                readOnly
                                disabled={isViewOpen || futureDate == 1}
                                withAsterisk
                                size="md"
                                styles={{
                                  input: {
                                    cursor:
                                      isViewOpen || futureDate == 1
                                        ? "not-allowed"
                                        : "pointer",
                                  },
                                }}
                                error={form.errors.createdAt}
                              />
                            </Popover.Target>

                            <Popover.Dropdown>
                              <Stack spacing="md" p="sm">
                                <DatePicker
                                  value={tempDate}
                                  onChange={(date) => {
                                    setTempDate(date);
                                  }}
                                  maxDate={new Date()}
                                  size="sm"
                                />

                                <TimeInput
                                  label="Select Time"
                                  placeholder="Select time"
                                  value={tempTime}
                                  onChange={(event) => {
                                    setTempTime(event.currentTarget.value);
                                  }}
                                  withAsterisk
                                  size="sm"
                                  icon={<IconClock size={16} />}
                                  format="12"
                                  withDropdown
                                />

                                <Group position="apart" mt="md">
                                  <Button
                                    variant="subtle"
                                    color="gray"
                                    size="xs"
                                    onClick={handleDateTimeClear}
                                  >
                                    Clear
                                  </Button>

                                  <Group spacing="xs">
                                    <Button
                                      variant="default"
                                      size="xs"
                                      onClick={() => setDateTimeOpened(false)}
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      size="xs"
                                      onClick={handleDateTimeApply}
                                      disabled={!tempDate}
                                      style={{
                                        backgroundColor: "#fab005",
                                        color: "#000",
                                      }}
                                    >
                                      Apply
                                    </Button>
                                  </Group>
                                </Group>
                              </Stack>
                            </Popover.Dropdown>
                          </Popover>
                        </Box>
                      </Box>
                    )}

                    {!isViewOpen && (
                      // !data?.form3?.discontinued &&
                      <div className={classes.saveButton}>
                        <Button
                          id="click-to-submit-dosage"
                          loading={btnLoading}
                          type="submit"
                          style={btnLoading ? { width: "170px" } : {}}
                          disabled={futureDate == 1 ? true : false}
                        >
                          <img src="/assets/images/save-icon.png" alt="" />
                          Save
                        </Button>
                      </div>
                    )}
                  </form>
                  {isViewOpen && !isEditOpen && (
                    <>
                      <div className={classes.info}>
                        <div className="column1">
                          <div>
                            <p>Administered by</p>
                            <h3>{data?.staff?.name}</h3>
                          </div>
                        </div>
                        {staffSignature?.signature ||
                        staffSignature?.signatureImage ? (
                          <div className="column2">
                            <p>Signature by</p>
                            <img
                              src={
                                decrypt(staffSignature?.signature) ||
                                decrypt(staffSignature?.signatureImage)
                              }
                              alt="signature"
                              width="180px"
                            />
                          </div>
                        ) : staffSignature?.signatureText ? (
                          <div className="column2">
                            <p>Signature by</p>
                            <Text
                              fz={26}
                              fw={400}
                              lh="normal"
                              ff="Island Moments"
                              color="#171717"
                            >
                              {staffSignature?.signatureText}
                            </Text>
                          </div>
                        ) : null}
                        <div className="column2">
                          <p>Date</p>
                          <h3>
                            {moment(data?.createdAt).format("MM/DD/YYYY")}
                          </h3>
                        </div>
                        <div className="column2">
                          <p>Time</p>
                          <>
                            {_medicationType !== _upcoming &&
                              moment(data.createdAt).isSameOrBefore(
                                moment()
                              ) && (
                                <h3>
                                  {moment(data?.createdAt).format("hh:mm a")}
                                </h3>
                              )}
                            {/* <h3>
                                  {moment(data?.createdAt).format("hh:mm a")}
                                </h3> */}
                          </>
                        </div>
                      </div>
                      {!(userType === "staff" && role === "staff") &&
                        isActivity !== true && (
                          <div className={classes.editButton}>
                            <Button
                              onClick={() => {
                                setIsEditOpen(true);
                              }}
                            >
                              Edit
                            </Button>
                          </div>
                        )}
                    </>
                  )}

                  {isEditOpen && (
                    <form
                      onSubmit={adminForm?.onSubmit((values) =>
                        handleAdminBy(values)
                      )}
                    >
                      <div className={classes.info}>
                        <div className="column1">
                          <div>
                            <p>Administered by</p>
                            {!(userType === "staff" && role === "staff") ? (
                              <Select
                                // data={staff?.staffs?.map((data) => {
                                //   return {
                                //     value: data?.id,
                                //     label: data?.name,
                                //   };
                                // })}
                                data={populateStaff?.map((data) => {
                                  return {
                                    value: data?.value,
                                    label: data?.label,
                                  };
                                })}
                                // style={{ zIndex: -1000 }}
                                placeholder="Select Staff"
                                {...adminForm.getInputProps("staff")}
                              />
                            ) : (
                              <h3>{data?.staff?.name}</h3>
                            )}
                          </div>
                        </div>
                        {staffSignature?.signature ||
                        staffSignature?.signatureImage ? (
                          <div className="column2">
                            <p>Signature by</p>
                            <img
                              src={
                                decrypt(staffSignature?.signature) ||
                                decrypt(staffSignature?.signatureImage)
                              }
                              alt="signature"
                              width="180px"
                            />
                          </div>
                        ) : staffSignature?.signatureText ? (
                          <div className="column2">
                            <p>Signature by</p>
                            <Text
                              fz={26}
                              fw={400}
                              lh="normal"
                              ff="Island Moments"
                              color="#171717"
                            >
                              {staffSignature?.signatureText}
                            </Text>
                          </div>
                        ) : null}
                        <div className="column2">
                          <p>Date</p>

                          {!(userType === "staff" && role === "staff") ? (
                            <DateInput
                              placeholder={"mm/dd/yyyy"}
                              rightSection={
                                <img
                                  style={{ width: "30px" }}
                                  src={"/assets/images/calendar-icon.png"}
                                  alt="Icon"
                                />
                              }
                              {...adminForm.getInputProps("date")}
                            />
                          ) : (
                            <h3>
                              {moment(data?.createdAt).format("MM/DD/YYYY")}
                            </h3>
                          )}
                        </div>
                        <div className="column2">
                          <p>Time</p>
                          {!(userType === "staff" && role === "staff") ? (
                            <TimeInput
                              ref={ref}
                              rightSection={
                                <ActionIcon
                                  variant="subtle"
                                  color="gray"
                                  onClick={() => ref?.current?.showPicker()}
                                >
                                  <IconClock
                                    style={{
                                      width: rem(16),
                                      height: rem(16),
                                    }}
                                    stroke={1.5}
                                  />
                                </ActionIcon>
                              }
                              {...adminForm.getInputProps("time")}
                            />
                          ) : (
                            <>
                              {_medicationType !== _upcoming &&
                                moment(data?.createdAt).isSameOrBefore(
                                  moment()
                                ) && (
                                  <h3>
                                    {/* {moment(data?.createdAt).format("hh:mm a")} */}

                                    {moment
                                      .tz(
                                        moment(data?.createdAt),
                                        profile?.user?.timeZone
                                      )
                                      .format("hh:mm a")}
                                  </h3>
                                )}
                            </>
                          )}
                        </div>
                      </div>
                      {!(userType === "staff" && role === "staff") && (
                        <div className={classes.updateButton}>
                          <div className={classes.editButton}>
                            <Button
                              onClick={() => {
                                setIsEditOpen(false);
                              }}
                            >
                              Cancel
                            </Button>
                          </div>
                          <Button
                            loading={btnLoading}
                            type="submit"
                            style={btnLoading ? { width: "180px" } : {}}
                          >
                            <img src="/assets/images/save-icon.png" alt="" />
                            Save
                          </Button>
                        </div>
                      )}
                    </form>
                  )}
                </div>
                <div className={classes.personInfo}>
                  <img src={decrypt(selectedClient?.imageurl)} />
                  <h3>{selectedClient?.name}</h3>
                  <p>{selectedClient?.id?.slice(0, 5)?.toUpperCase()}</p>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default MedicationModal;
